import { Component, Vue } from 'vue-property-decorator';
import topHead from './component/top-head/top-head.vue';
import leftMenu from './component/left-menu/left-menu.vue';
import orderMain from './component/order-main/order-main.vue';
@Component({
  components: { topHead, leftMenu, orderMain },
})
export default class PxOrderList extends Vue {
}
